import { apiProvider } from "./utilities/provider";
import { DiaryEntry } from "../../models/diary-entry";

export const diaryApi = {
  getAll: (): Promise<DiaryEntry[]> =>
    apiProvider.getAll("diary").then((d) => {
      return d;
    }),
  getSingle: (id: number): Promise<DiaryEntry> =>
    apiProvider.getSingle("diary", id),

  create: (entry: Partial<DiaryEntry>): Promise<void> => {
    const { id, ...entryWithoutId } = entry;
    return apiProvider.post("diary", entryWithoutId);
  },

  update: (entry: DiaryEntry): Promise<void> =>
    apiProvider.put("diary", entry.id, entry),

  delete: (id: number): Promise<void> => apiProvider.remove("diary", id),
};
